import { defineComponent as _defineComponent } from 'vue'
import { computed, PropType } from 'vue';
import { ComponentAddressData } from '@/models/Invoice';
import useUser from '@/mixins/useUser';


export default /*#__PURE__*/_defineComponent({
  __name: 'InvoiceAddressDataDisplay',
  props: {
  type: {
    type: String as PropType<'sender' | 'recipient'>,
    required: true,
  },
  addressData: {
    type: Object as PropType<ComponentAddressData>,
    required: true
  }
},
  setup(__props) {

const props = __props;

const { tUserFallback: t } = useUser('self');


const salutation = computed(() => {
  if (props.addressData.salutation === 'NONE') return '';
  return `${t(`invoice.address-data.salutationOptions.${props.addressData.salutation}`)} `;
});

/**
 * Computes a formatted string combining postal code, city, and country code from the address data.
 * If postal code or city is missing, only the country code is returned.
 *
 * @returns A string in the format "postalCode city, countryIsoCode" or just "countryIsoCode".
 */
const cityAndCountry = computed(() => {
  const address = props.addressData;
  const place = [address.postalCode, address.city].filter(Boolean).join(' ');
  return [place, address.countryIsoCode].filter(Boolean).join(', ');
});

/**
 * Creates the receiver's display name for an invoice.
 * Includes salutation, first name, and last name if available.
 *
 * @returns {string} The formatted receiver name or an empty string.
 */
function createReceiverName(): string {
  if (props.addressData.firstname || props.addressData.lastname) {
    return [
      t('invoice.address-data.form.attn_USERTYPE'),
      salutation.value,
      props.addressData.firstname,
      props.addressData.lastname
    ].filter(Boolean).join(' ');
  }
  return '';
}

/**
 * Returns sender company or full name.
 */
function createSenderCompany(): string {
  if (props.addressData.company) return props.addressData.company;

  if (props.addressData.firstname || props.addressData.lastname) {
    return [
      salutation.value,
      props.addressData.firstname,
      props.addressData.lastname
    ].filter(Boolean).join(' ');
  }
  return '';
}


return { __sfc: true,t, props, salutation, cityAndCountry, createReceiverName, createSenderCompany }
}

})